// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

export const ContactTitle = {
  UNDEFINED: 0,
  MISTER: 1,
  MRS: 2,
  MISS: 3,
  MASTER: 4,
  DOCTOR: 5,
};
